import React from "react";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="pt-[140px] pb-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <div className="overline mb-6">Informativa</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter font-medium mb-3">Privacy Policy</h1>
        <p className="text-sm text-[#5C5A55] mb-12">Ultimo aggiornamento: Dicembre 2025</p>

        <div className="prose-content space-y-8 text-[#1A1918] leading-relaxed">
          <section>
            <h2 className="font-display text-2xl mb-3">1. Titolare del trattamento</h2>
            <p className="text-[#5C5A55]">
              Il titolare del trattamento dei dati personali è <strong>Koreko Direct</strong>, con sede in Lungomare G. Caboto, 74 — Gaeta (LT). Email: korekodirect@gmail.com.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">2. Dati raccolti</h2>
            <p className="text-[#5C5A55]">
              Raccogliamo i dati personali che ci fornisci volontariamente attraverso i form del sito (preventivatore, contatti): nome, cognome, email, numero di telefono, città, configurazione di prodotto richiesta e messaggi.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">3. Finalità del trattamento</h2>
            <ul className="list-disc list-inside text-[#5C5A55] space-y-2">
              <li>Rispondere alle richieste di preventivo e di contatto</li>
              <li>Organizzare il sopralluogo tecnico gratuito</li>
              <li>Fornire informazioni sui nostri prodotti e servizi</li>
              <li>Adempiere agli obblighi di legge</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">4. Base giuridica</h2>
            <p className="text-[#5C5A55]">
              Il trattamento si fonda sul consenso dell'interessato (art. 6 GDPR) e sull'esecuzione di misure precontrattuali richieste.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">5. Conservazione dei dati</h2>
            <p className="text-[#5C5A55]">
              I dati sono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti e in ogni caso non oltre 24 mesi dall'ultimo contatto, salvo obblighi di legge.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">6. Diritti dell'interessato</h2>
            <p className="text-[#5C5A55]">
              Hai il diritto di accedere ai tuoi dati, chiederne la rettifica o la cancellazione, opporti al trattamento e richiederne la portabilità. Per esercitare questi diritti scrivi a <a href="mailto:korekodirect@gmail.com" className="text-[#EB0D0D] underline">korekodirect@gmail.com</a>.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">7. Cookie</h2>
            <p className="text-[#5C5A55]">
              Il sito utilizza esclusivamente cookie tecnici necessari al corretto funzionamento. Non vengono utilizzati cookie di profilazione di terze parti.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">8. Modifiche</h2>
            <p className="text-[#5C5A55]">
              Koreko Direct si riserva il diritto di modificare la presente informativa. Le modifiche saranno pubblicate su questa pagina.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
